import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { EmspUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/back-office-gateway-emsp-lib/src/outputs/emsp-users/emsp-user.model';
import { CellContext } from '@tanstack/react-table';

export interface EmspBoEmspUserListLastNameCellProps
  extends CellContext<EmspUserModel, EmspUserModel['lastName']> {}

export const EmspBoEmspUserListLastNameCell = (
  props: EmspBoEmspUserListLastNameCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return <Text truncate>{getValue()}</Text>;
};
